import { shape, string, node, oneOf } from "prop-types"
import Icon from "components/planning_center_icon"
import { useEffect } from "react"

const HelperShelfMessage = ({ style, id, children, initState = "closed" }) => {
  const helperShelfId = `helper_shelf_${id}`

  useEffect(() => {
    const node = document.getElementById(helperShelfId)
    if (!node) return
    node.style.height = initState === "closed" ? "0px" : `${node.scrollHeight}px`
  }, [])

  return (
    <div className="helper-shelf" data-helper-shelf={initState} id={helperShelfId} style={style}>
      <div className="helper-shelf__inner helper-container">
        <div className="helper-shelf__msg">{children}</div>
      </div>
    </div>
  )
}

const HelperShelfTrigger = props => {
  const handleClick = () => {
    const node = document.getElementById(`helper_shelf_${props.id}`)
    if (!node) return

    const isClosed = node.dataset.helperShelf === "closed"
    node.dataset.helperShelf = isClosed ? "open" : "closed"
    node.style.height = isClosed ? `${node.scrollHeight}px` : "0px"
  }

  return (
    <button
      className={props.className ?? "icon"}
      data-helper-shelf-id={`helper_shelf_${props.id}`}
      aria-label="Toggle helper shelf"
      style={props.style}
      onClick={handleClick}
      {...props}
    >
      <Icon symbol="general#outlined-info-circle" />
    </button>
  )
}

HelperShelfMessage.propTypes = {
  id: string,
  style: shape({}),
  children: node,
  initState: oneOf(["open", "closed"])
}

HelperShelfTrigger.propTypes = {
  id: string,
  className: string,
  style: shape({})
}

export { HelperShelfMessage, HelperShelfTrigger }
